<template>
    <div class="componente" :style="{width: width, height:heigth, position: position, top:top, left:left }">
     
        <v-switch
        disabled
        class="v-input--reverse"
      v-model="switch1"
      :label="`Auto-man`"
    ></v-switch>
    </div>
</template>
<script>
export default {
    data() {
        return {
            switch1:false
        }
    },//fin data
    props:{
        heigth: String,
        width: String,
        position: String,
        top:String,
        left: String,
        titulo: String,

        valor:Boolean
    },
    watch:{
        switch1(val){
            this.$emit('auto_man', val)
        }
    }
    
}
</script>
<style>
.componente{
    position: absolute;
   
}
.v-input--reverse .v-input__slot {
    flex-direction: row-reverse;
    justify-content: flex-end;

}
    
</style>